import { Nullable } from 'src/core/common/domain/types/types';
import { Attachment } from 'src/core/attachment/domain/attachment';

export const FileDownloadStatuses = {
  Pending: 'pending',
  Downloading: 'downloading',
  Saving: 'saving',
  Completed: 'completed',
  Cancelled: 'cancelled',
  Error: 'error',
} as const;

export type FileDownloadStatus = typeof FileDownloadStatuses[keyof typeof FileDownloadStatuses];

export type FileDownloadOptions = {
  timeoutInMilliseconds?: number;
  maxBytes?: Nullable<number>;
  preferUniqueFilename?: boolean;
  filename?: Nullable<string>;
};

export type FileDownloadProgress = {
  status: FileDownloadStatus;
  loadedBytes: number;
  totalBytes: Nullable<number>;
  progressPercentage: Nullable<number>;
  fileName: Nullable<string>;
  mimeType: Nullable<string>;
  attachment: Nullable<Attachment>;
  error: Nullable<unknown>;
};

export type FileDownloadTask = {
  progress$: import('rxjs').Observable<FileDownloadProgress>;
  cancel: () => void;
};
